import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";
import config from "../../config";
import { Grid } from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import { Box } from "@material-ui/core";

const BACKEND_URL = config.backend.host;

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
  imgSize: {
    width: "50px",
  },
  fab: {
    margin: theme.spacing(3),
    height: "10%",
    width: "3%",
    color: "white",
    backgroundColor: "#F6227F",
    "&:hover": {
      color: "white !important",
      backgroundColor: "#c41b63 !important",
    },
    borderRadius: 5,
  },
  button: {
    margin: 10,
  },
  extendedIcon: {
    marginRight: theme.spacing(),
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ededed",
    color: "black",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class ProductList extends Component {
  state = {
    _id: "",
    name: "",
    city: "",
    province: "",
    country: "",
    logo_small: "",
    products: [],
    loading: true,
  };
  constructor(props) {
    super(props);
    if (props.match.params.brandId) {
      //alert(props.match.params.brandId);
      //TODO: remove magic string
      axios
        .get(BACKEND_URL + `/brand/${props.match.params.brandId}`)
        .then((response) => this.loadData(response.data))
        .catch((err) => {
          // console.log(err)
        });
    }
  }
  loadData(brand) {
    // console.log("PRODUCT DATA", brand);
    this.setState({
      _id: brand._id,
      name: brand.name,
      city: brand.city,
      province: brand.province,
      country: brand.country,
      logo_small: brand.logo_small,
      products: brand.products,
      loading: false,
    });
  }
  btnDeleteOnClick(idBrand, id, e) {
    // console.log("Deleted>> ID:" + id);
    axios
      .delete(BACKEND_URL + `/product/${idBrand}/${id}`)
      .then(this.updateStateAfterDelete(id))
      .catch(function (error) {
        // console.log(error);
        //TODO: Show errors with snackbars
      });
  }
  updateStateAfterDelete(id) {
    //console.log('Deleted!');
    alert("Deleted!");
    this.setState({
      products: this.state.products.filter((p) => p._id !== id),
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid
          align="center"
          justify="space-evenly"
          container
          alignItems="center"
        >
          <Grid xs={8}>
            <Typography variant="h4">Product List</Typography>
            <Box borderRadius="borderRadius">
              <Typography variant="h6">BRAND: {this.state.name}</Typography>
            </Box>
          </Grid>
          <Tooltip title="Add Brand" aria-label="Brands">
            <Fab
              aria-label="Add"
              className={classes.fab}
              component={Link}
              to={`/admin/product/add/${this.state._id}`}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        </Grid>

        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Image</StyledTableCell>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Form</StyledTableCell>
              <StyledTableCell>Usage Period</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.products && this.state.products.length > 0 ? (
              this.state.products.map((product) => (
                <TableRow className={classes.row} key={product._id}>
                  <CustomTableCell align="left">
                    <img
                      alt=""
                      className={classes.imgSize}
                      src={
                        product.image && product.image[0]
                          ? product.image[0]
                          : null
                      }
                    />
                  </CustomTableCell>
                  <CustomTableCell align="left">{product.name}</CustomTableCell>
                  <CustomTableCell align="left">{product.type}</CustomTableCell>
                  <CustomTableCell align="left">{product.form}</CustomTableCell>
                  <CustomTableCell align="left">
                    {product.usage_period}
                  </CustomTableCell>
                  <CustomTableCell align="left">
                    <Tooltip title="Edit" aria-label="Edit">
                      <IconButton
                        aria-label="Edit"
                        className={classes.margin}
                        component={Link}
                        to={`/admin/product/edit/${this.state._id}/${product._id}`}
                      >
                        <EditIcon
                          fontSize="small"
                          style={{ color: "#F6277F" }}
                        />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Delete" aria-label="Delete">
                      <IconButton
                        aria-label="Delete"
                        className={classes.margin}
                        onClick={this.btnDeleteOnClick.bind(
                          this,
                          this.state._id,
                          product._id
                        )}
                      >
                        <DeleteIcon
                          fontSize="small"
                          style={{ color: "#F6277F" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </CustomTableCell>
                </TableRow>
              ))
            ) : (
              <TableRow className={classes.row} key={0}>
                <CustomTableCell align="center" colSpan={6}>
                  No products found
                </CustomTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {this.state.loading ? <LinearProgress /> : ""}
      </div>
    );
  }
}

export default withStyles(styles)(ProductList);
